import { useSyncExternalStore } from 'react';
import axios from 'axios';
import { domain } from './variables';

// Disponibilité du serveur du site : dès qu'un script PHP de server/ répond par une erreur 50x,
// l'application remplace son contenu par la page "site indisponible" (cf. App.js).
// Les services externes (livescore, API FFTT appelées directement...) ne sont pas concernés.
let serverDown = false;
const listeners = new Set();

const setServerDown = () => {
    if (serverDown) return;
    serverDown = true;
    listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

// À appeler dans un composant : true dès qu'une erreur 50x du serveur a été reçue
export const useServerDown = () => useSyncExternalStore(subscribe, () => serverDown);

// Intercepteur commun à tous les appels axios du site
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const url = error.config?.url || '';
        if (status >= 500 && status < 600 && url.startsWith(domain + '/server/')) {
            setServerDown();
        }
        return Promise.reject(error);
    }
);
